import React, { useEffect, useState, useMemo, createRef } from 'react';
import { StepControls } from '~/common/step-controls';
import { useSelector } from 'react-redux';
import { getArtworkListingsList, getSoundListingsList, selectNewSong } from '~/features/dashboard/store/selectors';
import { Controller, useForm } from 'react-hook-form';
import { INewSongStepSixFormInputs, ISongAssetFormInputs } from '~/models/music/new-song/formInputs';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';
import { NamedForm } from '~/features/dashboard/components/add-song/components/named-form';
import { Typography, Grid, Select, MenuItem, LinearProgress, Box, Chip, IconButton, Divider, Drawer, Tooltip } from '@material-ui/core';
import { Button } from '@material-ui/core';
import css from './styles.module.scss';
import Paper from '@material-ui/core/Paper';
import { orderBy } from 'lodash';
import { SongProjectTrack, songsDataTags } from '~/models/music/new-song/newSongResponse.dto';
import { axiosInstance } from '~/api/config/axios.config';
import Input from '@material-ui/core/Input';
import Avatar from '@material-ui/core/Avatar';
import { createNewSongStepSixThunk, deleteAssets, getSongTagsAssets, getTagListings, isrcSongTagLink } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { newSongFormNextStep } from '~/features/dashboard/store/actions';
import { useRouteMatch } from 'react-router-dom';
import { useDateFormat } from '~/common/date-format';
import classNames from 'classnames';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import fakeUserImagePNG from '~/img/fake-user-image.png';
import AudioPlayer from 'material-ui-audio-player';
import { makeStyles } from '@material-ui/styles';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Pause from '@material-ui/icons/Pause';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { EditSynchTab, ItemTypeSong } from '~/features/dashboard/components/song-details/coponents/EditSynchTab';
import { sortSongItems } from '~/utils/helpers';
import EditIcon from '@material-ui/icons/Edit';

interface Step_2Props {
    prevStep: () => void;
}

const useStyles = makeStyles(() => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            margin: 'auto',
            width: '100px',
            height: '100px',
            '& > *': {
                display: 'flex',
                alignItems: 'center',
            },
            '& > :nth-child(3)': {
                order: 1,
            },
        },
        playIcon: {
            fontSize: '2rem',
        },
        replayIcon: {
            fontSize: '2rem',
        },
        pauseIcon: {
            fontSize: '2rem',
        },
    };
});

export const Step_6: React.FC<Step_2Props> = ({ prevStep }) => {
    const { formatDate } = useDateFormat();
    const newSongState = useSelector(selectNewSong);
    const dispatch = useThunkDispatch();
    const [fileType, setFileType] = useState('');
    const icons = {
        PlayIcon: PlayArrow,
        PauseIcon: Pause,
    };

    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const fileUploadEl = createRef<any>();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [fileUploaded, setFileUploaded] = useState<ISongAssetFormInputs[]>([]);
    const [drag, setDrag] = useState<boolean>(false);
    const [songTag, setSongTag] = useState<songsDataTags[]>([]);
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jfif'];
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [progress, setProgress] = React.useState(0);
    const [ListUnlink, setListUnlink] = useState<songsDataTags[]>([]);
    const [file, setFile] = useState<songsDataTags>();
    let size: number = 0;
    const config = {
        onUploadProgress: (progressEvent: { loaded: any }) => {
            setProgress(Math.min((progressEvent.loaded / size) * 100, 100));
        },
    };

    const artworkAttr = useSelector(getArtworkListingsList);
    const artworkList: ItemTypeSong[] = useMemo(() => {
        if (artworkAttr && artworkAttr.length) {
            return sortSongItems(
                artworkAttr.map(i => ({ id: i.customField ? i.id : 0, customField: i.customField ? i.customField : 0, listingText: i.listingText }))
            );
        }
        return [];
    }, [artworkAttr]);

    const soundAttr = useSelector(getSoundListingsList);
    const soundList: ItemTypeSong[] = useMemo(() => {
        if (soundAttr && soundAttr.length) {
            return sortSongItems(
                soundAttr.map(i => ({ id: i.customField ? i.id : 0, customField: i.customField ? i.customField : 0, listingText: i.listingText }))
            );
        }
        return [];
    }, [soundAttr]);

    const { register, setValue, control, getValues, errors, clearErrors } = useForm<INewSongStepSixFormInputs>({
        defaultValues: {},
    });

    const [projectTrack, setProjectTrack] = useState<SongProjectTrack[]>([]);

    const dragStartHandler = (event: any) => {
        event.preventDefault();
        setDrag(true);
    };

    const dragLeaveHandler = (event: any) => {
        event.preventDefault();
        setDrag(false);
    };

    const dragOverHandler = (event: any) => {
        event.preventDefault();
        setDrag(true);
    };

    const onDropHandler = async (event: any) => {
        setLoading(true);
        clearErrors('files');
        event.preventDefault();
        let files = [...event.dataTransfer.files];
        const formDate = new FormData();
        size = 0;
        setFileType(files[0].type);
        files.map(async item => {
            let fileName = item.name;
            size += Number(item.size);
            formDate.append(fileName, item);
        });
        await axiosInstance.post('/catalogue/projectCreator/fileupload', formDate, config).then(resp => {
            setFileUploaded(resp.data);
            setLoading(false);
        });
        setDrag(false);
    };

    const dragStart = (event: any, file: songsDataTags) => {
        setFile(file);
    };

    const onDragOver = (event: any) => {
        event.preventDefault();
    };

    const onDrop = (event: any, item: any) => {
        const indexAssets = songTag.findIndex(item => item.songTagId === file?.songTagId);
        if (indexAssets !== -1) {
            setSongTag(prevState => {
                const newState = [...prevState];
                if (item?.isrc && item.isrc !== '') {
                    newState[indexAssets].isrc = item.isrc;
                    newState[indexAssets].linkedFlag = 1;
                    axiosInstance.delete(`/catalogue/projectCreator/isrcsongtaglink/delete/${newState[indexAssets].isrcSongTagLinkId}`);
                    dispatch(isrcSongTagLink({ isrc: item.isrc, songTagId: newState[indexAssets].songTagId || 0 })).then(
                        res => (newState[indexAssets].isrcSongTagLinkId = res.isrcSongTagLinkId)
                    );
                } else {
                    newState[indexAssets].isrc = '';
                    newState[indexAssets].linkedFlag = 0;
                    axiosInstance.delete(`/catalogue/projectCreator/isrcsongtaglink/delete/${newState[indexAssets].isrcSongTagLinkId}`);
                }
                return newState;
            });
        } else {
            item?.isrc
                ? dispatch(isrcSongTagLink({ isrc: item.isrc, songTagId: file?.id || 0 })).then(res => {
                      setSongTag([
                          ...songTag,
                          {
                              assetVersion: file?.assetVersion || '',
                              gSongArtworkTags: file?.gSongArtworkTags || '',
                              gSongFileName: file?.gSongFileName || '',
                              gSongFilePath: file?.gSongFilePath || '',
                              gSongSoundTags: file?.gSongSoundTags || '',
                              isrcSongTagLinkId: res.isrcSongTagLinkId || 0,
                              isrc: item?.isrc,
                              linkedFlag: 1,
                              songTagId: file?.id,
                          },
                      ]);
                  })
                : setSongTag([
                      ...songTag,
                      {
                          assetVersion: file?.assetVersion || '',
                          gSongArtworkTags: file?.gSongArtworkTags || '',
                          gSongFileName: file?.gSongFileName || '',
                          gSongFilePath: file?.gSongFilePath || '',
                          gSongSoundTags: file?.gSongSoundTags || '',
                          isrcSongTagLinkId: 0,
                          isrc: item?.isrc,
                          linkedFlag: 0,
                          songTagId: file?.id,
                      },
                  ]);
        }
    };

    useEffect(() => {
        newSongState && setProjectTrack(newSongState?.songProjectTrack);
        newSongState && setSongTag(newSongState?.songsDataTags);
    }, [newSongState, creatorId]);

    const removeAssets = async (item: any) => {
        setSongTag(songTag.filter(({ songTagId }) => songTagId !== item.songTagId));
        await axiosInstance.delete(`/catalogue/projectCreator/isrcsongtaglink/delete/${item.isrcSongTagLinkId}`).then(res => {
            console.log(res.data);
        });
        await dispatch(deleteAssets(item.songTagId));
    };

    const drawImage = () => {
        fileUploadEl.current.click();
    };
    const fileChange = async (event: any) => {
        // let file = ev.target.files[0];
        clearErrors('files');
        let files = [...event.target.files];
        size = 0;
        const formDate = new FormData();

        setFileType(files[0].type);
        files.map(async item => {
            let fileName = item.name;
            size += Number(item.size);
            formDate.append(fileName, item);
        });
        setLoading(true);
        await axiosInstance.post('/catalogue/projectCreator/fileupload', formDate, config).then(resp => {
            setFileUploaded(resp.data);
            setLoading(false);
        });
        setDrag(false);
    };

    const save = () => {
        fileUploaded.map(item => {
            const assetsFile = {
                assetVersion: getValues('assetVersion'),
                gSongFileName: item.fileName,
                gSongFilePath: item.filePath,
                gSongArtworkTags: getValues('artworkTag'),
                gSongSoundTags: getValues('soundTag'),
            };

            dispatch(createNewSongStepSixThunk({ ...assetsFile })).then(res =>
                setListUnlink(prevState => {
                    return [...prevState, res];
                })
            );
            return item;
        });
    };

    return (
        <NamedForm name={newSongState?.gSongName} onSubmit={() => console.log()}>
            <Drawer variant="persistent" anchor="right" open={isOpen} id="deal-edit-step-6-drawer" className={css.rightDrawer}>
                <Box className={css.contentWrapper}>
                    <Box className={css.closeDrawer}>
                        <IconButton
                            onClick={() => {
                                setIsOpen(!isOpen);
                                dispatch(getTagListings());
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography style={{ fontSize: '1rem' }}>Close</Typography>
                    </Box>
                    <Divider />
                    <Box style={{ padding: '0 12px' }}>
                        <EditSynchTab items={soundList} title={'Sound'} />
                        <EditSynchTab items={artworkAttr} title={'Artwork'} />
                    </Box>
                </Box>
            </Drawer>
            <Grid container spacing={3} style={{ justifyContent: 'flex-end', marginBottom: '15px' }}>
                <Grid item xs={4}>
                    <Paper className={classNames(css.paper, css.assetsWrapper)} elevation={2}>
                        <Box className={css.assetsHeader}>
                            <CloudUploadOutlinedIcon className={css.assetsIcon} />
                            <Typography style={{ minHeight: '30px' }} variant={'subtitle1'} className={css.bold}>
                                Upload
                            </Typography>
                        </Box>
                        {ListUnlink.length === 0 && (
                            <Paper className={classNames(css.paper, css.assetsContent)} elevation={2}>
                                <div
                                    className={css.dragDrop}
                                    onDragStart={dragStartHandler}
                                    onDragLeave={dragLeaveHandler}
                                    onDragOver={dragOverHandler}
                                    onDrop={onDropHandler}
                                >
                                    {fileUploaded.length > 0 ? (
                                        <>
                                            {validImageTypes.includes(fileType) ? (
                                                <div className={'flex'}>
                                                    {fileUploaded.map(item => (
                                                        <Box key={item.filePath || ''} className={css.boxItem}>
                                                            <Avatar
                                                                style={{ margin: '0 5px' }}
                                                                variant="square"
                                                                className={css.avatar}
                                                                alt={item.fileName || ''}
                                                                src={item.filePath || fakeUserImagePNG}
                                                            />
                                                        </Box>
                                                    ))}
                                                </div>
                                            ) : (
                                                fileUploaded.map(item => (
                                                    <Tooltip title={item.fileName} aria-label={item.fileName}>
                                                        <Box key={item.filePath || ''} className={css.boxItem}>
                                                            <AudioPlayer
                                                                key={item.filePath}
                                                                elevation={3}
                                                                spacing={1}
                                                                useStyles={useStyles}
                                                                src={item.filePath || ''}
                                                                timePosition="start"
                                                                icons={icons}
                                                                volume={false}
                                                                displaySlider={false}
                                                            />
                                                        </Box>
                                                    </Tooltip>
                                                ))
                                            )}
                                        </>
                                    ) : (
                                        <div className={css.DropContainer}>
                                            <CloudUploadOutlinedIcon className={css.dragDropIcon} />
                                            <Typography className={css.fieldName}>
                                                {isLoading ? 'Loading...' : drag ? 'Drop the file' : 'Drag and Drop Asset Files'}
                                            </Typography>
                                            {isLoading && <LinearProgress className={css.loading} variant="determinate" value={progress} />}
                                        </div>
                                    )}
                                </div>
                                {errors.files && <p className={css.error}>Please select a file or drag and drop</p>}
                                <Button onClick={drawImage} className={css.chooseFile}>
                                    Choose file
                                </Button>
                                <input hidden type="file" ref={fileUploadEl} onChange={fileChange} multiple />
                                <TextInput className={css.textInput} label="Asset Version" name={'assetVersion'} register={register} />
                                <input hidden name={'assetID'} ref={register} />
                                <input hidden name={'isrcSongTagLinkId'} ref={register} />
                                <div style={{ justifyContent: 'space-between' }} className="flex">
                                    <Typography className={css.fieldName}>Select Tag</Typography>
                                    <IconButton className={css.editButton} size="small" title="Edit Codes" onClick={() => setIsOpen(true)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </div>
                                <Controller
                                    setValue={setValue}
                                    render={props => (
                                        <Select
                                            className={css.selectInput}
                                            value={props.value}
                                            onChange={props.onChange}
                                            input={<Input />}
                                            inputProps={{ 'aria-label': 'Without label' }}
                                        >
                                            {!validImageTypes.includes(fileType) &&
                                                soundList.map(({ listingText }) => (
                                                    <MenuItem key={listingText} value={listingText}>
                                                        {listingText}
                                                    </MenuItem>
                                                ))}
                                            {validImageTypes.includes(fileType) &&
                                                artworkList.map(({ listingText }) => (
                                                    <MenuItem key={listingText} value={listingText}>
                                                        {listingText}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    )}
                                    name={validImageTypes.includes(fileType) ? 'artworkTag' : 'soundTag'}
                                    control={control}
                                />
                                {errors.soundTag && <p className={css.error}>{errors.soundTag.message}</p>}
                                <Button className={css.btnSave} onClick={save}>
                                    Save
                                </Button>
                            </Paper>
                        )}
                        {ListUnlink.length > 0 && (
                            <Paper className={classNames(css.paper, css.assetsContent)} elevation={2}>
                                <CloseIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setListUnlink([]);
                                        setFileUploaded([]);
                                        setValue('assetVersion', '');
                                        setValue('assetID', '');
                                        setValue('isrcSongTagLinkId', '');
                                    }}
                                />
                                <div>
                                    <div className={'flex'} style={{ justifyContent: 'center' }}>
                                        {ListUnlink.map(item => (
                                            <Tooltip title={item.gSongFileName || ''} aria-label={item.gSongFileName || ''}>
                                                {item.gSongArtworkTags ? (
                                                    <Box key={item.gSongFilePath || ''} className={css.boxItem} onDragStart={e => dragStart(e, item)} draggable>
                                                        <Avatar
                                                            draggable="true"
                                                            onDragStart={e => dragStart(e, item)}
                                                            variant="square"
                                                            className={css.avatar}
                                                            alt={item.gSongFileName || ''}
                                                            src={item.gSongFilePath || fakeUserImagePNG}
                                                        />
                                                        <Chip style={{ marginTop: '10px' }} label={item.gSongArtworkTags} />
                                                    </Box>
                                                ) : (
                                                    <Box key={item.gSongFilePath || ''} className={css.boxItem} onDragStart={e => dragStart(e, item)} draggable>
                                                        <AudioPlayer
                                                            elevation={3}
                                                            spacing={1}
                                                            useStyles={useStyles}
                                                            src={item.gSongFilePath || ''}
                                                            timePosition="start"
                                                            icons={icons}
                                                            volume={false}
                                                            displaySlider={false}
                                                        />
                                                        <Chip style={{ marginTop: '10px' }} label={item.gSongSoundTags} />
                                                    </Box>
                                                )}
                                            </Tooltip>
                                        ))}
                                    </div>
                                </div>
                            </Paper>
                        )}
                    </Paper>
                </Grid>
                <Grid item xs={8}>
                    <Typography style={{ margin: '10px 0' }} variant={'h6'} className={'bold'}>
                        Song Level Assets
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <Paper className={classNames(css.paper, css.assetsWrapper)} elevation={2}>
                                <Box className={css.assetsMeta}>
                                    <Typography style={{ minHeight: '30px' }} variant={'subtitle1'} className={classNames(css.Typography, 'bold')}>
                                        Release Date: <span>{newSongState?.gSongReleaseDate ? formatDate(newSongState?.gSongReleaseDate) : 'MISSING'}</span>
                                    </Typography>
                                </Box>
                                <Paper className={classNames(css.paper, css.assetsContent)} elevation={2}>
                                    <Box className={css.assetsContainer}>
                                        {newSongState?.gMyWriterName && (
                                            <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                Writer: <span>{newSongState?.gMyWriterName}</span>
                                            </Typography>
                                        )}
                                        {newSongState?.gWriterShare ? (
                                            <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                Writer Share: <span>{newSongState?.gWriterShare}%</span>
                                            </Typography>
                                        ) : (
                                            ''
                                        )}
                                        {newSongState?.gPublisherName && (
                                            <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                Publisher: <span>{newSongState?.gPublisherName}</span>
                                            </Typography>
                                        )}
                                        {newSongState?.gPublishingShare ? (
                                            <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                Publisher Share: <span>{newSongState?.gPublishingShare}%</span>
                                            </Typography>
                                        ) : (
                                            ''
                                        )}
                                        {newSongState?.gSongCode2 && (
                                            <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                Society-IPI/CAE Number: <span>{newSongState?.gSongCode2}</span>
                                            </Typography>
                                        )}
                                    </Box>
                                </Paper>
                            </Paper>
                        </Grid>
                        <Grid item xs={7}>
                            <Paper className={classNames(css.paper, css.assetsWrapper)} elevation={2}>
                                <Box className={css.assetsMeta}>
                                    <Typography variant={'subtitle1'} className={'bold'}>
                                        Attached assets
                                    </Typography>
                                </Box>
                                <Paper
                                    onDragOver={onDragOver}
                                    onDrop={e => onDrop(e, '')}
                                    className={classNames(css.paper, css.assetsContent, 'flex')}
                                    elevation={2}
                                >
                                    {songTag &&
                                        songTag
                                            .filter((elem: any) => elem.linkedFlag === 0)
                                            .map(item =>
                                                item.gSongArtworkTags?.length ? (
                                                    <Tooltip title={item.gSongFileName || ''} arrow placement="top">
                                                        <Box
                                                            onDragStart={e => dragStart(e, item)}
                                                            draggable
                                                            key={item.gSongFilePath || ''}
                                                            className={css.boxItem}
                                                        >
                                                            <CloseIcon className={css.deleteIcon} onClick={() => removeAssets(item)} />
                                                            <Avatar
                                                                variant="square"
                                                                className={css.avatar}
                                                                alt={item.assetVersion || ''}
                                                                src={item.gSongFilePath || fakeUserImagePNG}
                                                            />
                                                            <Chip style={{ marginTop: '10px' }} label={item.gSongArtworkTags} />
                                                        </Box>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title={item.gSongFileName || ''} arrow placement="top">
                                                        <Box
                                                            onDragStart={e => dragStart(e, item)}
                                                            draggable
                                                            key={item.gSongFilePath || ''}
                                                            className={css.boxItem}
                                                        >
                                                            <CloseIcon
                                                                style={{ top: '0', right: '0' }}
                                                                className={css.deleteIcon}
                                                                onClick={() => removeAssets(item)}
                                                            />
                                                            <AudioPlayer
                                                                elevation={3}
                                                                spacing={1}
                                                                useStyles={useStyles}
                                                                src={item.gSongFilePath || ''}
                                                                timePosition="start"
                                                                icons={icons}
                                                                volume={false}
                                                                displaySlider={false}
                                                            />
                                                            <Chip style={{ marginTop: '10px' }} label={item.gSongSoundTags} />
                                                        </Box>
                                                    </Tooltip>
                                                )
                                            )}
                                </Paper>
                            </Paper>
                        </Grid>
                    </Grid>
                    {projectTrack && projectTrack.length > 0 && (
                        <>
                            <Typography style={{ margin: '10px 0' }} variant={'h6'} className={'bold'}>
                                Track Level Assets
                            </Typography>
                            {orderBy(projectTrack, ['releaseDate'], ['asc']).map((item, num) => (
                                <Grid key={`projectTrack-${num}-${item.isrc}`} container spacing={2} style={{ overflowY: 'scroll' }}>
                                    <Grid item xs={5}>
                                        <Paper className={classNames(css.paper, css.assetsWrapper)} elevation={2}>
                                            <Box className={css.assetsMeta}>
                                                <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                    ISRC <span>{item.isrc}</span>
                                                </Typography>
                                            </Box>
                                            <Paper className={classNames(css.paper, css.assetsContent)} elevation={2}>
                                                <Box key={item.isrc} className={css.assetsContainer}>
                                                    {item.trackArtist && (
                                                        <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                            Artist: <span>{item.trackArtist}</span>
                                                        </Typography>
                                                    )}
                                                    {item.trackTitle && (
                                                        <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                            Title: <span>{item.trackTitle}</span>
                                                        </Typography>
                                                    )}
                                                    {item.trackLabel && (
                                                        <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                            Label: <span>{item.trackLabel}</span>
                                                        </Typography>
                                                    )}
                                                    <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                        UPC: <span>{item.upcList.join(', ')}</span>
                                                    </Typography>
                                                    <Typography variant="subtitle1" className={classNames(css.Typography, 'bold')} align="left">
                                                        Release Date: <span>{item.releaseDate ? formatDate(item.releaseDate) : 'MISSING'}</span>
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Paper className={classNames(css.paper, css.assetsWrapper)} elevation={3}>
                                            <Box className={css.assetsMeta}>
                                                <Typography variant={'subtitle1'} className={'bold'}>
                                                    Attached assets
                                                </Typography>
                                            </Box>
                                            <Paper
                                                onDragOver={onDragOver}
                                                onDrop={e => onDrop(e, item)}
                                                className={classNames(css.paper, css.assetsContent, 'flex')}
                                                elevation={1}
                                            >
                                                {songTag
                                                    ?.filter((elem: any) => elem.isrc === item.isrc)
                                                    .map(item =>
                                                        item.gSongArtworkTags?.length ? (
                                                            <Tooltip title={item.gSongFileName || ''} arrow>
                                                                <Box
                                                                    key={item.gSongFilePath || ''}
                                                                    className={css.boxItem}
                                                                    onDragStart={e => dragStart(e, item)}
                                                                    draggable
                                                                >
                                                                    <CloseIcon className={css.deleteIcon} onClick={() => removeAssets(item)} />
                                                                    <Avatar
                                                                        variant="square"
                                                                        className={css.avatar}
                                                                        alt={item.assetVersion || ''}
                                                                        src={item.gSongFilePath || fakeUserImagePNG}
                                                                    />
                                                                    <Chip style={{ marginTop: '10px' }} label={item.gSongArtworkTags} />
                                                                </Box>
                                                            </Tooltip>
                                                        ) : (
                                                            <Tooltip title={item.gSongFileName || ''} arrow>
                                                                <Box
                                                                    key={item.gSongFilePath || ''}
                                                                    className={css.boxItem}
                                                                    onDragStart={e => dragStart(e, item)}
                                                                    draggable
                                                                >
                                                                    <CloseIcon
                                                                        style={{ top: '0', right: '0' }}
                                                                        className={css.deleteIcon}
                                                                        onClick={() => removeAssets(item)}
                                                                    />
                                                                    <AudioPlayer
                                                                        elevation={3}
                                                                        spacing={1}
                                                                        useStyles={useStyles}
                                                                        src={item.gSongFilePath || ''}
                                                                        timePosition="start"
                                                                        icons={icons}
                                                                        volume={false}
                                                                        displaySlider={false}
                                                                    />
                                                                    <Chip style={{ marginTop: '10px' }} label={item.gSongSoundTags} />
                                                                </Box>
                                                            </Tooltip>
                                                        )
                                                    )}
                                            </Paper>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            ))}
                        </>
                    )}
                </Grid>
            </Grid>
            <StepControls
                className={css.nextButton}
                onNextClick={() => {
                    dispatch(newSongFormNextStep());
                    dispatch(getSongTagsAssets());
                }}
                onPrevClick={prevStep}
            />
        </NamedForm>
    );
};
